import React from 'react'
import { HexColorPicker } from "react-colorful";
import Button from '../UI/button'
import SvgIcon from '../SVG/svg'
import ThInputText from './th-input-text'
import cn from 'classnames'
import { Form } from 'react-bootstrap'
type Props = {
  initialColor: string
  onChange: (color: string) => void
}

const ThColorPicker = ({ initialColor, onChange }: Props) => {
  const [color, setColor] = React.useState<string>(initialColor.replace('#', ''))
  const [active, setActive] = React.useState<boolean>(false)
  const [wasClicked, setWasClicked] = React.useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setColor(event.target.value.replace('#', ''))
    onChange(event.target.value.replace('#', ''))
  }

  const handleChange = (color: string) => {
    setColor(color.replace('#', ''))
    onChange(color.replace('#', ''))
  }

  const handleClickInput = (e: React.MouseEvent<HTMLInputElement>) => {
    e.stopPropagation()
    if (!wasClicked) {
      setActive(true);
      setWasClicked(true);
    }
  };

  return (
    <div className={cn('color-picker', {
      'active': active
    })}>
      <label htmlFor='color-picker'>Select Color</label>
      <Button variant='outline-primary' width='full' height={46} px={10} className='color-picker-button mx-auto' onClick={() => setActive(!active)}>
        <div className='color-picker-current-color'>
          <span style={{ backgroundColor: `#${color}` }}></span>
          <div className='color-picker-input'>
            <input onClick={handleClickInput} type="text" value={color} onChange={handleInputChange} maxLength={6} className='color-picker-input-text' />
            <div className='prefix'>#</div>
          </div>
        </div>
        <SvgIcon type='settings' />
      </Button>
      <div className='color-picker-wrapper'>
        <HexColorPicker
          color={color}
          onChange={handleChange}
        />
        <Button variant='outline-primary' px={50} className='mx-auto' onClick={() => setActive(false)}>Select</Button>
      </div>
    </div>
  )
}
export default ThColorPicker